import type { AssignTarget, CreverseGuestAdmission } from '@mathflat/domain/Guest'

/**
 * 배정 모달이 다루는 비재원생 입학시험 회차 1건.
 * DualListBoxV2 는 item.id 로 키잉/검색하므로 (guestId, admissionRefId) 를 합성 id 로 묶어
 * 한 비재원생의 여러 회차를 별 행으로 식별한다.
 */
export type GuestAdmission = CreverseGuestAdmission & { id: string }

const ID_DELIMITER = ':'

/** (guestId, admissionRefId) ↔ 합성 id 코덱 */
export const guestAdmissionId = {
  stringify: ({ guestId, admissionRefId }: AssignTarget): GuestAdmission['id'] =>
    `${guestId}${ID_DELIMITER}${admissionRefId}`,
  parse: (id: GuestAdmission['id']): AssignTarget => {
    const i = id.indexOf(ID_DELIMITER)
    return { guestId: Number(id.slice(0, i)), admissionRefId: id.slice(i + 1) }
  },
}

export const toGuestAdmission = (admission: CreverseGuestAdmission): GuestAdmission => ({
  ...admission,
  id: guestAdmissionId.stringify(admission),
})

/** 만료 회차는 노출 제외하되, 기배정 회차는 배정 취소 경로를 위해 우측에 남겨야 하므로 유지 */
export const filterVisibleAdmissions = (
  admissions: GuestAdmission[],
  assignedAdmissionIds: GuestAdmission['id'][],
): GuestAdmission[] => {
  const assignedSet = new Set(assignedAdmissionIds)
  return admissions.filter(({ expired, id }) => !expired || assignedSet.has(id))
}
